module.exports = __webpack_public_path__ + "static/Dialogue-c730c4fccb334cb026b967a43e620fd2.jpg";